import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Section = styled.section``;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 24px;
  }
`;

export const Title = styled(Typography.Header)`
  margin: 0;
  font-size: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 20px;
  }
`;

export const AddCardLink = styled(Button).attrs({
  appearance: 'secondaryText',
  hasPadding: false,
  isAutoWidth: true,
  size: 's',
})`
  flex-shrink: 0;
  height: auto;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 15px;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
`;

export const DropdownMenu = styled.div`
  width: 200px;
  flex-direction: column;
  padding: 10px 5px;
`;

export const DropdownMenuItem = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 44px;
  border-radius: 9px;
  padding: 0 15px;
  text-align: left;

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const DropdownMenuItemText = styled(Typography.Body).attrs(() => ({
  $variant: '1',
}))<{ $isDangerous?: boolean }>`
  color: ${({ theme, $isDangerous }) =>
    $isDangerous ? theme.palette.system.red : theme.palette.primary.labels};
`;
